import { AxiosRequestConfig } from 'axios';

const endpoint = '/api/block';

export default {
    getBlocks: () => ({ method: 'GET', url: `${endpoint}` } as AxiosRequestConfig),
    getAllBlocks: () => ({ method: 'GET', url: `${endpoint}/all` } as AxiosRequestConfig),
    syncBlocks: () => ({ method: 'PATCH', url: `${endpoint}/sync` } as AxiosRequestConfig),
};
